import gql from 'graphql-tag';

export const STATIC_SEO = gql`
  query staticPage($url: String!) {
    staticPage(url: $url) {
      seoMeta {
        seoTitle
        seoDescription
        seoKeywords
      }
    }
  }
`;

export const STATIC_SEO_WITH_DESCRIPTION = gql`
  query staticPage($url: String!) {
    staticPage(url: $url) {
      descr
      seoMeta {
        seoTitle
        seoDescription
        seoKeywords
      }
    }
  }
`;

